import { OrderDevice } from 'Portal/src/mappers/orderDeviceMapper/orderDevice.types'
import { parseItemTypeForLimitationRules } from 'Portal/src/utilities/parseItemTypeForLimitationRules/parseItemTypeForLimitationRules.util'

import { OrderLimitations } from './orderStore.types'

export const adjustChosenDeviceLimitationRules = (
  limitationRules: OrderLimitations | null,
  chosenDevice: OrderDevice | null,
  mode: 'add' | 'remove',
) => {
  if (!limitationRules || !chosenDevice) {
    return null
  }

  let newLimitationRules: OrderLimitations = {
    ...limitationRules,
  }

  const deviceType = parseItemTypeForLimitationRules(chosenDevice)

  if (mode === 'add') {
    newLimitationRules = {
      ...limitationRules,
      [deviceType]: {
        ...limitationRules[deviceType],
        current: limitationRules[deviceType].current + 1,
      },
    }
  } else {
    newLimitationRules = {
      ...limitationRules,
      [deviceType]: {
        ...limitationRules[deviceType],
        current: limitationRules[deviceType].current - 1,
      },
    }
  }

  return newLimitationRules
}

export const adjustChosenAccessoriesLimitationRules = (
  limitationRules: OrderLimitations | null,
  chosenAccessories: Map<string, OrderDevice>,
  mode: 'add' | 'remove',
) => {
  if (!limitationRules) {
    return null
  }

  let newLimitationRules: OrderLimitations = {
    ...limitationRules,
  }

  for (const [_, accessory] of chosenAccessories) {
    const accessoryType = parseItemTypeForLimitationRules(accessory)

    if (mode === 'add') {
      newLimitationRules = {
        ...newLimitationRules,
        [accessoryType]: {
          ...newLimitationRules[accessoryType],
          current: newLimitationRules[accessoryType].current + 1,
        },
      }
    } else {
      newLimitationRules = {
        ...newLimitationRules,
        [accessoryType]: {
          ...newLimitationRules[accessoryType],
          current: newLimitationRules[accessoryType].current - 1,
        },
      }
    }
  }

  return newLimitationRules
}

export const adjustChosenAccessoryLimitationRules = (
  limitationRules: OrderLimitations | null,
  accessory: OrderDevice,
  mode: 'add' | 'remove',
) => {
  if (!limitationRules) {
    return null
  }

  let newLimitationRules: OrderLimitations = {
    ...limitationRules,
  }

  const productType = parseItemTypeForLimitationRules(accessory)

  if (mode === 'add') {
    newLimitationRules = {
      ...limitationRules,
      [productType]: {
        ...limitationRules[productType],
        current: limitationRules[productType].current + 1,
      },
    }
  } else {
    newLimitationRules = {
      ...limitationRules,
      [productType]: {
        ...limitationRules[productType],
        current: limitationRules[productType].current - 1,
      },
    }
  }

  return newLimitationRules
}
